<template>
    <div class="clearfix main_center">

        <div class="right-content">
            <el-form ref="form" :model="form" :rules="rules" label-width="150px" class="form">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>政策法规文件</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="标题：" prop='title' style="width:100%;">
                                    <el-input v-model="form.title" class="limit-word-input" maxlength="100" show-word-limit ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="发布时间：" prop='releaseTime' size="small">
                                    <el-date-picker
                                            v-model="form.releaseTime"
                                            style="width: 100%"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type="datetime"
                                            placeholder="选择时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="内容：" prop='content' size="small">
                                    <tinymceEditor :content.sync="form.content" :key="tinymceKey"></tinymceEditor>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>附件信息</span>
                    </div>
                    <template>
                        <div class="affixDown" v-if="form.attachments.length > 0" style="margin-bottom: 10px">
                            <affixMsg
                                    v-for="(item, index) in form.attachments"
                                    :item.sync="item"
                                    labelWidth="150px"
                                    :index="index"
                                    :key="index"
                                    :showModal="false"
                                    :name="item.titleName"
                            >
                            </affixMsg>
                        </div>
                        <p style="text-align: center" v-if="form.attachments.length == 0">暂无附件数据</p>
                    </template>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button size="small" type="primary" @click="dataFormSubmit">保存</el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        httpGetAttsByBusinessId,
        httpMixinsCommonPost,
        httpMixinsDetail,
    } from "@/server/purchase";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import affixMsg from "@/components/affixMsg";
    import tinymceEditor from "@/components/tinymceEditor/Index";

    export default {
        components: {
            affixMsg,
            tinymceEditor
        },
        data() {
            return {
                tableMaxHeight: document.documentElement.clientHeight - 267,
                cardHight: (document.documentElement.clientHeight - 116) + 'px',
                rules: {
                    title: [{required: true, message: '请填写见证记录', trigger: 'blur'}],
                    content: [{ required: true, message: '内容不能为空', trigger: 'change' }],
                    releaseTime: [{ required: true, message: '请选择日期', trigger: 'change' }],
                },
                tinymceKey:Math.random(),
                form: {
                    title:'',
                    releaseTime:'',
                    content:'',
                    attachments:[],
                },
                id: '', //点击提交的时候也传id
                tableData: [],
                pageSize: 10,//每页条数
                pageIndex: 1,//当前页
                total: 0,//总条数,
                parterList: [],
            }
        },
        computed: {

        },
        activated() {
            this.id = this.$route.query.id;
            this.getDataById();

        },
        methods: {
            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            dataFormSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if(this.form.attachments[0].attFiles.length == 0){
                            this.$message.error('请上传附件数据。')
                            return
                        }
                        this.formLoading = true;
                        httpMixinsCommonPost("/purchase/policiesRegulations/saveOrUpdate", this.form)
                            .then(res => {
                                this.formLoading = false;
                                if (res.data.code == "1") {
                                    this.$message({
                                        type: "success",
                                        message: res.data.msg
                                    });
                                    tabsCloseCurrentHandle();
                                    this.$router.push({
                                        name: 'lawfile'
                                    })
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.data.msg
                                    });
                                }
                            });
                    }
                });
            },
            backBtn() { //返回
                tabsCloseCurrentHandle();
                this.$router.push({
                    name: 'lawfile'
                })
                this.$refs.form.resetFields();
            },
            getDataById() { //详情
                if (this.id != "") {
                    httpMixinsDetail('/purchase/policiesRegulations/get/' + this.id).then((res) => {
                        if (res.data.code === '1') {
                            const data = res.data.data;
                            this.form = {...data};
                            httpGetAttsByBusinessId('policies_regulations', this.id,  true).then((resData) => {
                                let resAttachment = resData.data.map(item => {
                                    return {
                                        ...item,
                                        disabledUpload: false,
                                    }
                                })
                                this.$set(this.form,'attachments',resAttachment)
                            })
                        }
                    })
                }else{
                    this.form.content = '';
                    this.tinymceKey = Math.random();
                    this.$refs.form.resetFields()
                    httpGetAttsByBusinessId('policies_regulations', '',  true).then((resData) => {
                        let resAttachment = resData.data.map(item => {
                            return {
                                ...item,
                                disabledUpload: false,
                            }
                        })
                        this.$set(this.form,'attachments',resAttachment)
                    })
                }
            },
        }


    }
</script>

<style lang="less" scoped>
    .angle_tag{
        margin-right: 10px !important;
    }
</style>